import React, { FC, useMemo, useState } from 'react';
import stylesModule from './Filters.module.less';
import { Button, Checkbox, Divider, Input, Space } from 'antd';
import { useCachedData } from '../../../../connection/CacheContext';
import Utils from '../../../../utils/Utils';
import { SearchQuery, useSearchContext } from '../../SearchContext';
import { FilterTitle } from './FilterTitle';

const styles: any = stylesModule;

type Props = {
  search?: boolean;
  allText?: string;
  value?: string[];
  title: string;
  onChange?: (value?: string[]) => void;
  getQuery?: (value?: string[]) => SearchQuery;
  onCancel?: () => void;
  id?: string;
};

export const TypeFilter: FC<Props> = (props) => {
  const { onChange, search: showSearch } = props;
  const [searchText, setSearchText] = useState<string>();
  const ctx = useSearchContext();
  const [value, setValue] = useState<string[] | undefined>(props.value);
  const { activeEnumValue } = useCachedData();
  const typeData = useMemo(() => {
    const st: any[] = Object.entries(activeEnumValue['Job Types'])
      .map((v) => [v, (ctx.results?.aggs as any)?.['jobType']?.[v[0]] ?? 0])
      .map((v) => [v[0], v[1] === 0 ? '' : ` (${v[1]})`])
      .map((v) => ({
        label: `${v[0][1]}${v[1]}`,
        value: `Job Types-${v[0][0]}`,
      }));
    return st;
  }, [ctx.results?.aggs, activeEnumValue]);

  const categoryData = useMemo(() => {
    const st: any[] = Object.entries(activeEnumValue['Job Category'])
      .map((v) => [v, (ctx.results?.aggs as any)?.['jobCategory']?.[v[0]] ?? 0])
      .map((v) => [v[0], v[1] === 0 ? '' : ` (${v[1]})`])
      .map((v) => ({
        label: `${v[0][1]}${v[1]}`,
        value: `Job Category-${v[0][0]}`,
      }));
    return st;
  }, [ctx.results?.aggs, activeEnumValue]);

  const typeDataToShow = useMemo(() => {
    if (showSearch && (searchText ?? '') === '') {
      return typeData.filter((s) => (props.value ? props.value?.indexOf(s.value) === -1 : true));
    }
    return typeData.filter((s) =>
      searchText ? s.label.toLowerCase().indexOf(searchText?.toLowerCase()) !== -1 : true,
    );
  }, [typeData, props.value, searchText, showSearch]);

  const categoryDataToShow = useMemo(() => {
    if (showSearch && (searchText ?? '') === '') {
      return categoryData.filter((s) =>
        props.value ? props.value?.indexOf(s.value) === -1 : true,
      );
    }
    return categoryData.filter((s) =>
      searchText ? s.label.toLowerCase().indexOf(searchText?.toLowerCase()) !== -1 : true,
    );
  }, [categoryData, props.value, searchText, showSearch]);

  return (
    <Space size={16} direction="vertical" className={styles.filterArea}>
      <FilterTitle
        id={props.id ?? 'master-data-filter'}
        title={props.title}
        onApply={() => onChange?.(value && value.length > 0 ? value : undefined)}
        onCancel={props.onCancel}
      />
      {showSearch && (
        <Input
          placeholder={'Search'}
          allowClear
          value={searchText}
          onChange={(event) => setSearchText(event.target.value)}
        />
      )}
      <div
        className={Utils.mergeClasses({
          [styles.filterAreaSearch]: showSearch ?? false,
        })}>
        <Space direction="vertical">
          {props.allText && (searchText ?? '') === '' && (
            <>
              <Checkbox
                key={'all'}
                value={'all'}
                checked={!value}
                onChange={(e) => {
                  if (e.target.checked) {
                    setValue(undefined);
                  }
                }}>
                {props.allText}
              </Checkbox>
              <Divider style={{ margin: 0 }} />
            </>
          )}
          <Space direction="vertical">
            {typeDataToShow.map((val) => (
              <Checkbox
                onChange={(e) =>
                  setValue(
                    e.target.checked
                      ? [...(value ?? []), val.value]
                      : (value ?? []).filter((v) => v !== val.value),
                  )
                }
                checked={(value ?? []).indexOf(val.value) !== -1}
                key={val.value}
                value={val.value}>
                {val.label}
              </Checkbox>
            ))}
            {categoryDataToShow.length > 0 && typeDataToShow.length > 0 && (
              <Divider style={{ margin: 0 }} />
            )}
            {categoryDataToShow.map((val) => (
              <Checkbox
                onChange={(e) =>
                  setValue(
                    e.target.checked
                      ? [...(value ?? []), val.value]
                      : (value ?? []).filter((v) => v !== val.value),
                  )
                }
                checked={(value ?? []).indexOf(val.value) !== -1}
                key={val.value}
                value={val.value}>
                {val.label}
              </Checkbox>
            ))}
          </Space>
        </Space>
      </div>
      <Button
        className={styles.applyButton}
        type={'primary'}
        size={'small'}
        onClick={() => onChange?.(value && value.length > 0 ? value : undefined)}>
        Apply
      </Button>
    </Space>
  );
};
